<template>
  <p v-if="!initialized" class="mt-5 text-center">
    Loading Shipment Data...
  </p>
  <div v-else-if="organization.shippingAddress">
    <pre
      >{{ organization.shippingAddress.name }}
{{ organization.shippingAddress.street }} {{ organization.shippingAddress.streetNumber }}
{{ organization.shippingAddress.zip }} {{ organization.shippingAddress.city }}
      </pre
    >
    <Shipments :orderId="orderId" :contactPerson="contactPerson" :receiver="receiver" ref="shipments" />
    <div class="d-flex justify-content-end mt-5">
      <button class="btn btn-primary" @click="closeOrder" :disabled="order.state === 'shipped'">Close Order</button>
    </div>
  </div>
  <div v-else>
    <h1 class="h3 mb-3">{{ order.organizationName }}</h1>
    <div class="alert alert-warning" role="alert">
      Can't create shipping labels due to missing shipping address
    </div>
  </div>
</template>

<script>
import Shipments from '@/components/Shipments'
import { auth, db, fb } from '@/shared/firebase'

export default {
  components: { Shipments },
  data() {
    return {
      initialized: false,
      organization: null,
      order: null
    }
  },
  async created() {
    const { orderId } = this
    this.$route.meta.backLink = `/orders/${orderId}`
    const order = await db
      .doc(`orders/${orderId}`)
      .get()
      .then(doc => doc.data())
    const organization = await db
      .doc(`organizations/${order.organizationId}`)
      .get()
      .then(doc => doc.data())
    this.order = order
    this.organization = organization
    this.initialized = true
  },
  computed: {
    orderId() {
      return this.$route.params.orderId
    },
    contactPerson() {
      let contactPerson = null
      if (this.organization.contactPersons) {
        const qualifiedPerson = this.organization.contactPersons.find(contactPerson => contactPerson.qualifiedForOrders)
        if (qualifiedPerson) contactPerson = `${qualifiedPerson.firstName} ${qualifiedPerson.lastName}`
      }
      return contactPerson
    },
    receiver() {
      const shippingAddress = this.organization.shippingAddress
      return {
        name1: shippingAddress.name,
        name2: shippingAddress.name2 || '',
        streetName: shippingAddress.street,
        streetNumber: shippingAddress.streetNumber,
        city: shippingAddress.city,
        zip: shippingAddress.zip,
        countryCode: 'DE'
      }
    }
  },
  methods: {
    closeOrder() {
      let confirmed = confirm('Close Order?')
      if (confirmed && this.$refs.shipments.shipments.length === 0) {
        confirmed = false
        confirmed = confirm(`WARNING: The Order has no shipments! Are you sure you wan't to close it?`)
      }
      if (confirmed) {
        let kioskItems = []
        if (this.order.kioskOrder) {
          kioskItems = _.cloneDeep(this.order.kioskOrder.items)
          kioskItems.forEach(item => {
            const pickedItems = this.order.pickedItems.filter(pickedItem => pickedItem.productId === item.productId)
            const hasExpiryDates = pickedItems.filter(pickedItem => pickedItem.expiryDate).length > 0
            if (hasExpiryDates) {
              item.expiryDates = pickedItems
                .filter(pickedItem => pickedItem.expiryDate)
                .map(pickedItem => {
                  return {
                    expiryDate: pickedItem.expiryDate,
                    amount: pickedItem.amount
                  }
                })
            }
          })
        }
        db.doc(`orders/${this.orderId}`)
          .update(
            this.order.kioskOrder
              ? {
                  state: 'shipped',
                  deliveryDate: new Date(),
                  'kioskOrder.items': kioskItems
                }
              : {
                  state: 'shipped',
                  deliveryDate: new Date()
                }
          )
          .then(() => {
            this.$router.push({ name: 'ordersOverview' })
          })
        const today = new Date().toISOString().substr(0, 10)
        db.doc(`private/logs/warehouseActivities/${today}`).set(
          {
            [auth.currentUser.uid]: fb.firestore.FieldValue.arrayUnion({
              action: 'orderClosed',
              timestamp: new Date(),
              orderId: this.orderId
            })
          },
          { merge: true }
        )
      }
    }
  }
}
</script>

<style>
.input-group-text {
  width: 175px;
}
</style>
